// Ubicación en el repo: src/lib/examEmail.js
// "✉️ Enviar por correo" en el detalle de audiometría (DECISIONS.md #119,
// pedido de Nicolás 16-sep-2026, tema 2 de 5). Genera el mismo informe que
// ya se imprime (buildExamReportHTML, examReport.jsx) como PDF en el propio
// navegador (pdfExport.js) y lo manda como adjunto a través de la Edge
// Function `send-exam-report-email`, que llama a Resend — mismo patrón que
// el resto de los correos a pacientes del proyecto (notify-appointment-
// cancellation, etc.).
import { supabase } from './supabaseClient';
import { buildExamReportHTML } from './examReport';
import { htmlToPdfBase64 } from './pdfExport';
import { formatPatientName } from './format';

export async function sendExamReportEmail(exam, logoUrl, signatureUrl) {
  const patient = exam.patients || {};
  if (!patient.email) {
    throw new Error('El paciente no tiene un correo registrado en su ficha.');
  }

  const { html } = buildExamReportHTML(exam, logoUrl, signatureUrl);
  const pdfBase64 = await htmlToPdfBase64(html);

  const safeName = (formatPatientName(patient) || 'paciente').replace(/[^\w-]+/g, '_');
  const pdfFilename = `Audiometria-${safeName}-${exam.date}.pdf`;

  const { data, error } = await supabase.functions.invoke('send-exam-report-email', {
    body: {
      examId: exam.id,
      patientId: exam.patient_id,
      examDate: exam.date,
      pdfBase64,
      pdfFilename,
    },
  });
  if (error) throw error;
  if (!data?.sent) {
    throw new Error(data?.error || 'No se pudo enviar el correo.');
  }
  return data;
}
